(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shams-growth-layer"] && !Shopify.designMode) return;
  try {
    const initStickyAtc = () => {
    const sticky = document.querySelector('[data-shams-sticky-atc]');
    if (!sticky) return;

    const mainButton = document.querySelector('.product-form__submit');
    const stickySelect = sticky.querySelector('[data-shams-sticky-variant]');
    const stickyPrice = sticky.querySelector('[data-shams-sticky-price]');
    const stickySubmit = sticky.querySelector('[data-shams-sticky-submit]');

    const setVisibility = (visible) => {
      sticky.hidden = !visible;
      document.body.classList.toggle('shams-sticky-visible', visible);
    };

    if (mainButton && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => setVisibility(!entry.isIntersecting), {
        rootMargin: '0px 0px -80px 0px',
        threshold: 0.05,
      });
      observer.observe(mainButton);
    } else {
      setVisibility(true);
    }

    const updateSticky = (variantId) => {
      if (!stickySelect) return;
      const option = Array.from(stickySelect.options).find((item) => item.value === String(variantId));
      if (!option) return;
      stickySelect.value = option.value;
      const price = Number(option.dataset.price || 0) / 100;
      if (stickyPrice) {
        const locale = document.documentElement.lang === 'ar' ? 'ar-EG' : 'en-EG';
        stickyPrice.textContent = new Intl.NumberFormat(locale, { style: 'currency', currency: 'EGP' }).format(price);
      }
      if (stickySubmit) stickySubmit.disabled = option.dataset.available !== 'true';
    };

    stickySelect?.addEventListener('change', (event) => updateSticky(event.target.value));

    document.addEventListener('change', (event) => {
      const control = event.target;
      if (!(control instanceof HTMLInputElement || control instanceof HTMLSelectElement)) return;
      if (sticky.contains(control)) return;
      if (control.name !== 'id') return;
      updateSticky(control.value);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc, { once: true });
  } else {
    initStickyAtc();
  }
  } catch(e) { console.error(e); }
})();

})();
